export default __webpack_public_path__ + "static/your_health_and_hATTR_amyloidosis-d6de44965b97f8110b740d4b8f7ff39c.pdf";